export const TARGETS = {
  // eslint-disable-next-line id-length
  SIGN_IN_WITH_EMAIL_AND_PASSWORD: 'signInWithEmailAndPassword'
};

export const MISSING_TENANT_ID = 'missing-tenant-id';
